// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");

function markUrlAsTrusted(settings, url) {
  if (Belt_Option.isSome(Caml_option.undefined_to_opt(settings.webSrcSettings.find(function (ws) {
                  return ws.url === url;
                })))) {
    return {
            parens: settings.parens,
            asrtsToSkip: settings.asrtsToSkip,
            asrtsToSkipRegex: settings.asrtsToSkipRegex,
            editStmtsByLeftClick: settings.editStmtsByLeftClick,
            defaultStmtType: settings.defaultStmtType,
            checkSyntax: settings.checkSyntax,
            typeSettings: settings.typeSettings,
            webSrcSettings: settings.webSrcSettings.map(function (ws) {
                  if (ws.url === url) {
                    return {
                            alias: ws.alias,
                            url: ws.url,
                            trusted: true
                          };
                  } else {
                    return ws;
                  }
                })
          };
  } else {
    return {
            parens: settings.parens,
            asrtsToSkip: settings.asrtsToSkip,
            asrtsToSkipRegex: settings.asrtsToSkipRegex,
            editStmtsByLeftClick: settings.editStmtsByLeftClick,
            defaultStmtType: settings.defaultStmtType,
            checkSyntax: settings.checkSyntax,
            typeSettings: settings.typeSettings,
            webSrcSettings: settings.webSrcSettings.concat([{
                    alias: "",
                    url: url,
                    trusted: true
                  }])
          };
  }
}

exports.markUrlAsTrusted = markUrlAsTrusted;
/* No side effect */
